import { Injectable, NgZone } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: "root" })
export class ConsoleDetectService {
  private password = environment.consolePassword;
  private wasOpen = false;
  private sessionAllowed = false;
  private intervalId?: number;
  private readonly checkInterval = 1500;
  private readonly threshold = 160;

  // Check for dev tools and handle if open
  private checkForDevTools() {
    this.ngZone.runOutsideAngular(() => {
      if (this.isDevToolsOpen()) {
        this.ngZone.run(() => this.handleDevToolsOpen(true));
      }
    });
  }

  constructor(private router: Router, private ngZone: NgZone) {


     const enableConsoleLock =  environment.production;

    if (enableConsoleLock) {
     this.checkForDevTools();

    // Also check once DOM is fully loaded
    if (document.readyState === 'complete') {
      this.checkForDevTools();
    } else {
      window.addEventListener('load', () => {
        this.checkForDevTools()
      });
    }

    this.ngZone.runOutsideAngular(() => {
      // Prevent DevTools shortcuts & right-click
      this.blockRightClick();
      this.bindShortcutDetection();
      this.startDetection();
    });

    // Restore session if password already validated this browser session
    this.sessionAllowed = sessionStorage.getItem("consoleAuth") == "true";
    }
    // Run initial check immediately
   
  }

  // 🚫 Disable right-click context menu
  private blockRightClick() {
    window.addEventListener("contextmenu", (e) => e.preventDefault());
  }

  // 🧠 Main detection loop
  private startDetection() {
    this.intervalId = window.setInterval(() => {
      if (!document.hasFocus()) return;

      const devToolsOpen = this.isDevToolsOpen();

      if (devToolsOpen && !this.wasOpen) {
        this.wasOpen = true;
        this.ngZone.run(() => this.handleDevToolsOpen(true));
      } else if (!devToolsOpen && this.wasOpen) {
        this.wasOpen = false;
      }
    }, this.checkInterval);
  }

  // 🕵️‍♂️ Check heuristics for open DevTools
  private isDevToolsOpen(): boolean {
    try {
      const widthDiff =
        Math.abs(window.outerWidth - window.innerWidth) > this.threshold;
      const heightDiff =
        Math.abs(window.outerHeight - window.innerHeight) > this.threshold;

      let consoleTriggered = false;
      const element = new Image();
      Object.defineProperty(element, "id", {
        get() {
          consoleTriggered = true;
          return "";
        },
      });
      console.log("%c", element);

      return widthDiff || heightDiff || consoleTriggered;
    } catch {
      return false;
    }
  }

  // ⌨️ Block F12 / Ctrl+Shift+I/J/C/K/U / Cmd+Opt+I/J (Mac)
  private bindShortcutDetection() {
    window.addEventListener("keydown", (e: KeyboardEvent) => {
      const key = e.key?.toLowerCase?.() ?? "";
      console.log("Keyyyy Pressed1");
      console.log(key);
      console.log("--------------------");

      // 🪟 Windows/Linux Detection
      const winDetect =
        e.key == "F12" ||
        (e.ctrlKey && e.shiftKey && ["i", "j", "c", "k", "u"].includes(key));

      // 🍎 macOS Detection
      const macDetect = e.metaKey && e.altKey && ["i", "j"].includes(key);

      // 🧠 Optional: some browsers use Cmd+Opt+C for Elements tab — cover that too
      const extraMacDetect =
        (e.metaKey && e.altKey && ["c", "k", "u"].includes(key)) ||
        key == "dead" ||
        (e.metaKey && e.altKey);

      if (winDetect || macDetect || extraMacDetect) {
        e.preventDefault();
        e.stopPropagation();
        this.ngZone.run(() => this.handleDevToolsOpen(true));
      }
    });
  }

  // 🔐 Ask for password once per session
  private async handleDevToolsOpen(preBootstrap = false) {
    if (this.sessionAllowed || environment.production == false) return;

    // 🚨 1. Handle pre-bootstrap DevTools (before app fully loads)
    if (preBootstrap) {
      sessionStorage.clear();
      localStorage.clear();
      window.location.href = "/login";
    }

    const overlay = document.getElementById(
      "console-lock-overlay"
    ) as HTMLDivElement;
    const input = document.getElementById(
      "console-lock-input"
    ) as HTMLInputElement;
    const errorText = document.getElementById(
      "console-lock-error"
    ) as HTMLParagraphElement;
    const button = document.getElementById(
      "console-lock-btn"
    ) as HTMLButtonElement;

    if (!overlay || !input || !button) return;

    overlay.style.display = "flex";
    errorText.style.display = "none";
    input.value = "";
    input.focus();
    document.body.style.overflow = "hidden";

    const checkPassword = () => {
      const entered = input.value.trim();
      if (entered == this.password) {
        this.sessionAllowed = true;
        sessionStorage.setItem("consoleAuth", "true");
        overlay.style.display = "none";
        document.body.style.overflow = "auto";
      } else {
        errorText.style.display = "block";
        input.classList.add("login-email-field-red");
        input.value = "";
        input.focus();
      }
    };

    input.addEventListener("keydown", (e) => {
      if (e.key == "Enter") checkPassword();
    });
    button.addEventListener("click", checkPassword);
  }

  public destroy() {
    if (this.intervalId) clearInterval(this.intervalId);
  }
}
